
import { Options, mixins } from "vue-class-component";
import StoreReports from "../../service/StoreReports";
import UtilityOptions from "../../mixins/UtilityOptions";
import AutoComplete from "primevue/autocomplete";
import Paginator from "primevue/paginator";
import moment from "moment";

@Options({
  title: 'Statement of General Journal',
  components: { AutoComplete, Paginator },
})
export default class GeneralJournal extends mixins(UtilityOptions) {
  private lists = [];
  private reportService;
  private resultTitle = "";
  private storeName = "";
  private productDialog = false;
  private loading = false;
  private home = { icon: "pi pi-home", to: "/" };
  private items = [
    { label: "Reports", to: "index" },
    { label: "Statement of General Journal", to: "general-journal-report" },
  ];

  private searchFilters = {
    id: "",
    date1: "",
    date2: "",
    filterType: "None",
    storeType: "single_store",
    storeID: 0,
    page: 1,
  };

  private totalPages = 0;
  private totalRecords = 0;
  private currentPage = 1;

  private filterDates = [];
  private dialogTitle;
  private submitted = false;
  private filterBranch = [];
  private moment = moment;

  created() {
    this.reportService = new StoreReports();
  }

  mounted() {
    this.storeList();
  }

  openDialog() {
    this.submitted = false;
    this.dialogTitle = "Filter Report";
    this.productDialog = true;
  }

  storeList() {
    this.loading = true;

    this.reportService.getFilterList().then((res) => {
      this.filterBranch = res.branches.map(b => ({
        ...b,
        id: Number(b.id),
      }));
      this.filterDates = res.datesList;
      this.searchFilters.storeID = Number(res.current_branch_id);
      this.searchFilters.storeType = 'single_store';
      this.loadList();
    });
  }

  loadList() {
    this.loading = true;

    this.searchFilters.storeType = (this.searchFilters.storeID && this.searchFilters.storeID !== 0)
      ? 'single_store'
      : 'all_stores';

    this.reportService.generalJournal(this.searchFilters).then((res) => {
      const data = this.camelizeKeys(res);
      this.resultTitle  = data.resultTitle;
      this.storeName    = data.storeName;
      this.lists        = data.record;
      this.totalPages   = data.totalPages;
      this.totalRecords = data.totalRecords;
      this.currentPage  = data.currentPage;
      this.loading      = false;
    });
    this.productDialog = false;
  }

  sumTotalAmount(trans, type) {
    let total = 0;
    trans.forEach(e => {
      if (e.type == type) {
        total = total + Number(e.amount);
      }
    });
    return total;
  }

  get currency() {
    return this.store.getters.getCurrency;
  }

  clearForFilters() {
    this.searchFilters.date1 = "";
    this.searchFilters.date2 = "";
  }

  clearSearch() {
    this.searchFilters.filterType = "None";
  }

  searchAndLoad() {
    this.searchFilters.page = 1;
    this.loadList();
  }

  onPage(event) {
    const newPage = Math.floor(event.first / 20) + 1;
    this.searchFilters.page = newPage;
    this.loadList();
  }
}
